import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Stats, Marquee } from "../components/site/Stats";
import { Bento } from "../components/site/Bento";
import { Origin } from "../components/site/Origin";
import { HowTo, Compare } from "../components/site/HowTo";
import { OrderForm } from "../components/site/OrderForm";
import { Faq, Newsletter, Footer } from "../components/site/Faq";
import { SmoothScroll } from "../components/site/Smooth";
import { NatureBand } from "../components/site/NatureBand";

export default function Landing() {
  return (
    <main className="overflow-x-clip" data-testid="landing-page">
      <SmoothScroll />
      <Header />
      <Hero />
      <Stats />
      <Marquee />
      <Bento />
      <Origin />
      <HowTo />
      <NatureBand />
      <Compare />
      <OrderForm />
      <Faq />
      <Newsletter />
      <Footer />
    </main>
  );
}
